export const VACATION = 'VAC';
export const ABSENCE = 'ABS';
export const REGULAR = 'REG';